export default function NowPlaying({ nowPlaying, loading }) {
  if (loading && !nowPlaying) {
    return (
      <div className="card animate-pulse h-24">
        <div className="h-3 bg-white/10 rounded w-1/3 mb-3" />
        <div className="h-4 bg-white/10 rounded w-2/3" />
      </div>
    )
  }
  if (!nowPlaying || !nowPlaying.song_title) {
    return (
      <div className="card">
        <p className="text-xs text-peak-muted">Now playing</p>
        <p className="text-peak-muted">— silence —</p>
      </div>
    )
  }
  return (
    <div className="card flex items-center gap-3">
      {nowPlaying.album_art ? (
        <img src={nowPlaying.album_art} alt="" className="w-14 h-14 rounded-lg object-cover" />
      ) : (
        <div className="w-14 h-14 rounded-lg bg-peak-accent/30 grid place-items-center">♪</div>
      )}
      <div className="min-w-0 flex-1">
        <p className="text-xs text-peak-accent uppercase tracking-wide font-semibold">
          Now playing
        </p>
        <p className="font-semibold truncate">{nowPlaying.song_title}</p>
        <p className="text-sm text-peak-muted truncate">{nowPlaying.artist}</p>
      </div>
    </div>
  )
}
